// extracted by mini-css-extract-plugin
module.exports = {"compMemb":"CompanyLogo_compMemb__3QPYB","compname":"CompanyLogo_compname__bxLnB","toolbarLogo":"CompanyLogo_toolbarLogo__1SnC9","companyBox":"CompanyLogo_companyBox__1Ibk9"};